module.exports = "pegasus/assets/blocks/column-9-theme2.png";